<div class="loader_session" *ngIf='loaderdata'>
    <div class="loader-4"><span></span>
  </div>
  </div>
  

<div
  class="catalog-head"
  style="background-image: url(assets/image/Group-1892.png)"
>
  <div class="catalog-head-content">

      <h2>LIBRARY</h2>

  </div>
</div>
<!-- catalog search -->
<div class="container">
  <div class="mt-5">
    <div class="row">
        <div class="col-md-4">
            <div class="searchform">
              <div class="row">
                <div class="col-md-8">
                  <div class="input-group mb-3" #searchkey>
                    <ng-autocomplete [data]="wikiItems" [searchKeyword]="searchkey"
                        placeholder="Enter your keywords" (selected)="onSelect($event)"
                        (inputChanged)="searchd($event)" [itemTemplate]="itemTemplate">
                    </ng-autocomplete>

                    <ng-template #itemTemplate let-item>
                        <a [innerHTML]="item"></a>
                    </ng-template>

                    <ng-template #notFoundTemplate let-notFound>
                        <div [innerHTML]="notFound"></div>
                    </ng-template>

                </div>

              </div>
         
                    <!-- <div  > -->
                    <!-- <input type="text" name="searchkey"  class="form-control" placeholder="Enter your keywords" aria-label="Recipient's username" aria-describedby="basic-addon2" #searchkey> -->
                    <!-- <input input-autocomplete [items]="wikiItems" class="form-control"   (inputChangedEvent)="searchd($event)" (selectEvent)="onSelect($event)" #searchkey> -->

                    <div class=" col-md-4">
                        <button type="button" class="btn btn-primary" style="background-color: #d5b256;border-color: #d5b256;" (click)="onsubmitbtn()">
                            Search
                        </button>
                    </div>

                    <!-- <div *ngFor="let items of _instruction">
          <div>
            <input type="checkbox" name="{{ items.name }}" />
            <label>{{ items.name }}</label>
          </div>
        </div> -->
                </div>
                <!-- <input style="width: 15px; height: 15px" class="ml-1 pt-2 mr-2 my-1" type="checkbox"
                    (change)="oncheckedadv($event)" /> -->
                <!-- <label class="my-1">Advanced Keyword Search <i class="fa fa-question-circle mx-2 pop-data " aria-hidden="true" (click)=popup()></i> 
                <span class="popup"> 
                   Contents will appear here...
                </span>
                </label> -->
            </div>
            <!-- <div class="catalog">
                <h3>FILTER RESULTS</h3>
                <P> Categories </P>
            </div> -->
            <!-- <div *ngFor="let item of _Mainmenu">
                <div style="display: block; width: 100%">
                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                    <input type="checkbox" name="{{ item.name }}" class="mx-3 my myCSSclass" (change)="onchanges()"
                        [(ngModel)]="item.isselected" />
                    <label>{{ item.name }}</label>
                </div>
            </div> -->

          

           
        </div>
     

        <div class="col-md-4">
          <div class="loader" *ngIf="loaderitem">
            <div class="lds-dual-ring " ></div>
          </div>
         
            <div class="my-3">
                <div *ngFor="let datas of datafromapi; index as i;" class="my-5">
               
                    <div class="row">
                        <div class="col-2">
                            <!-- <a (click)="printout($event)" href="{{ datas.metadata_storage_path }}" target="_blank">
                                <img width="100%" src="/assets/image/istockphoto-1298834280-612x612.jpg" alt=""
                                    srcset="" /></a> -->
                                    <span  (click)="printout(datas.wfileurl)" style="cursor:pointer;">
                                        <img width="100%" src="/assets/image/istockphoto-1298834280-612x612.png" alt="">
                                    </span>
                        </div>

                        <div class="col-10">
                            <h3 style="padding: 0" class="mb-2">
                                {{
                                datas.metadata_storage_name
                                .split(".")
                                .slice(0, -1)
                                .join(".")
                                }}
                            </h3>
                            <p>
                                <!-- <i style="color: rgb(112, 112, 112)">
                                    Published on:
                                    {{
                                    datas.metadata_storage_last_modified | date: "yyyy-MM-dd"
                                    }}
                                </i> -->
                            </p>
                            <a href="{{ datas.wfileurl }}" download target="_blank"
                                class="btn btn-primary" style="background-color: #d5b256;border-color: #d5b256;">download</a>
                        </div>
                    </div>
                
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div *ngIf="_DisplayUrls">
            
                <iframe [src]=_DisplayUrls name="iframe_a" height="100vh" style="min-height: 500px;" width="100%" title="Iframe Example"></iframe>
            </div>
           
        </div>
    </div>
</div>
</div>

<app-contactform></app-contactform>